import { defineMessages } from 'react-intl';

/** Copy that more than one Settings tab prints (design settings-redesign a-e). */
export const settingsCommonMessages = defineMessages({
  saving: { id: 'app.sml.settings.saving', defaultMessage: 'Saving' },
  saved: { id: 'app.sml.settings.saved', defaultMessage: 'Saved' },
  saveFailed: { id: 'app.sml.settings.saveFailed', defaultMessage: 'We could not save that. Try again.' },
  backToSettings: { id: 'app.sml.settings.back', defaultMessage: 'Settings' },
  railLabel: { id: 'app.sml.settings.rail.label', defaultMessage: 'Settings sections' },
});
